import React, { FC, useState, useEffect } from 'react'

import ModalWrapper from '../../components/Modal/ModalWrapper'
import Input from '../../components/Input'
import Button from '../../components/Button'
import CrossIcon from '../../icons/cross.svg'

interface IProps {
  visible: boolean
  currentAmount?: number
  locationCode?: string
  onSave: (amount: number, reason: string) => void
  onClose: () => void
}

const EditAmountModal: FC<IProps> = ({
  visible,
  currentAmount,
  locationCode,
  onSave,
  onClose,
}) => {
  const [amount, setAmount] = useState('')
  const [reason, setReason] = useState('')

  useEffect(() => {
    if (visible) {
      setAmount(currentAmount !== undefined ? String(currentAmount) : '')
      setReason('')
    }
  }, [visible, currentAmount])

  if (!visible) return null

  const handleSave = () => {
    if (!isValid) return
    onSave(parsedAmount, reason.trim())
  }

  const parsedAmount = parseInt(amount, 10)
  const reasonTrimmed = reason.trim()
  const isValid =
    !isNaN(parsedAmount) &&
    parsedAmount >= 0 &&
    reasonTrimmed.length > 0 &&
    reasonTrimmed.length <= 25

  const title = locationCode ? `Edit Amount — ${locationCode}` : 'Edit Amount'

  return (
    <ModalWrapper className="edit-amount-modal">
      <button
        className="edit-amount-modal_backdrop clear-button"
        onClick={onClose}
      />
      <div className="edit-amount-modal_dialog">
        <div className="edit-amount-modal_title">{title}</div>
        <CrossIcon className="edit-amount-modal_close" onClick={onClose} />
        <div className="edit-amount-modal_form">
          <Input
            label="New amount"
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value.replace(/[^0-9]/g, ''))}
            error={parsedAmount < 0 ? 'Amount cannot be negative' : undefined}
          />
          <Input
            label="Reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Why are you updating this amount?"
            maxLength={25}
            error={
              reason.trim().length > 25
                ? 'Reason cannot exceed 25 characters'
                : undefined
            }
          />
        </div>
        <div className="edit-amount-modal_actions">
          <Button color="success" disabled={!isValid} onClick={handleSave}>
            Save
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </div>
      </div>
    </ModalWrapper>
  )
}

export default EditAmountModal
